import { create } from 'zustand';

export const useWorkflowTemplateStore = create((set) => ({
    items: [],
    loading: false,
    error: null,
    columnFilters: {},
    uniqueValues: {},

    paginationData: {
        currentPage: 1, totalPages: 1, totalItems: 0, itemsPerPage: 20,
        hasNextPage: false, hasPreviousPage: false,
    },

    searchParams: {
        scope: 'tenant',
        entityType: '',
        code: '',
        isPublished: undefined,
    },

    isFormOpen: false,
    isEditMode: false,
    selectedTemplate: null,
    deleteDialogOpen: false,
    templateToDelete: null,

    setItems: (items) => set({ items }),
    setLoading: (loading) => set({ loading }),
    setError: (error) => set({ error }),
    setColumnFilters: (columnFilters) => set({ columnFilters }),
    setUniqueValues: (uniqueValues) => set({ uniqueValues: uniqueValues || {} }),
    clearError: () => set({ error: null }),
    setPaginationData: (paginationData) => set({ paginationData }),
    setSearchParams: (params) => set((state) => ({ searchParams: { ...state.searchParams, ...params } })),

    openAddForm: () => set({ isFormOpen: true, isEditMode: false, selectedTemplate: null, error: null }),
    openEditForm: (template) => set({ isFormOpen: true, isEditMode: true, selectedTemplate: template, error: null }),
    closeForm: () => set({ isFormOpen: false, selectedTemplate: null, error: null }),

    openDeleteDialog: (template) => set({ deleteDialogOpen: true, templateToDelete: template }),
    closeDeleteDialog: () => set({ deleteDialogOpen: false, templateToDelete: null }),
}));
